import { h365PlatformApi } from '@/plugin/axios'

function extractToken(data) {
  if (typeof data === 'string') return data
  if (data && typeof data === 'object') return data.token || null
  return null
}

function extractIsNewUser(data) {
  if (data && typeof data === 'object') return !!data.isNewUser
  return false
}

export async function happymallLogin(payload) {
  const response = await h365PlatformApi.post('/user/happymall-login', payload)
  return {
    ...response,
    token: response.code === 0 ? extractToken(response.data) : null,
    isNewUser: response.code === 0 ? extractIsNewUser(response.data) : false,
  }
}

export async function happymallBindLogin(payload) {
  const response = await h365PlatformApi.post('/user/happymall-bindlogin', payload)
  return {
    ...response,
    token: response.code === 0 ? extractToken(response.data) : null,
    isNewUser: false,
  }
}
